/**
 * achtBytes IoT API
 * The achtBytes IoT API handles all portal functionality.
 *
 * The version of the OpenAPI document: v1
 * Contact: info@achtbytes.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderState = 0 | 1 | 2;

export const OrderState = {
    NUMBER_0: 0 as OrderState,
    NUMBER_1: 1 as OrderState,
    NUMBER_2: 2 as OrderState
};

